import { ErpDocumentation } from '../pages/Erp/ErpDocumentation';
import { PublicApiDocumentation } from '../pages/PublicApi';

export const DocumentationRoutes = [
  {
    path: '/integracao-erp/:docVersion?',
    isPrivate: false,
    exact: false,
    component: <ErpDocumentation />,
  },
  {
    path: '/api-integration',
    isPrivate: false,
    exact: false,
    component: <PublicApiDocumentation />,
  },
];
